import { useEffect } from "react";

import { useState } from "react";
import { PageLoading } from "../../../components/page_loading";
import Grid from "@mui/joy/Grid";
import Typography from "@mui/joy/Typography";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import FormHelperText from "@mui/joy/FormHelperText";

export const VpcComponent = (props: {
  loading: boolean;
  deploymentId: string;
  vpcStackParamsJson: string | null;
  vpcStackStatus: string | null;
}) => {
  const { loading, vpcStackParamsJson, vpcStackStatus } = props;

  const [vpcCidr, setVpcCidr] = useState<string>("");
  const [primaryPrivateCidr, setPrimaryPrivateCidr] = useState<string>("");
  const [secondaryPrivateCidr, setSecondaryPrivateCidr] = useState<string>("");
  const [primaryPublicCidr, setPrimaryPublicCidr] = useState<string>("");
  const [secondaryPublicCidr, setSecondaryPublicCidr] = useState<string>("");

  useEffect(() => {
    if (vpcStackParamsJson) {
      const params = JSON.parse(vpcStackParamsJson);
      setVpcCidr(params.VPCCidr || "");
      setPrimaryPrivateCidr(params.PrimaryPrivateCidr || "");
      setSecondaryPrivateCidr(params.SecondaryPrivateCidr || "");
      setPrimaryPublicCidr(params.PrimaryPublicCidr || "");
      setSecondaryPublicCidr(params.SecondaryPublicCidr || "");
    }
  }, [vpcStackParamsJson]);

  return (
    <>
      <PageLoading loading={loading} />
      <Grid container spacing={2} sx={{ flexGrow: 1 }}>
        <Grid xs={12}>
          <Typography level="body-sm" sx={{ py: 1 }}>
            CloudFormation stack status: {vpcStackStatus || "Not deployed"}
          </Typography>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>VPC CIDR</FormLabel>
            <Input
              disabled={true}
              value={vpcCidr}
              onChange={(event) => {
                setVpcCidr(event.target.value);
              }}
            />
            <FormHelperText>The CIDR block for the VPC.</FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Primary Private CIDR</FormLabel>
            <Input
              disabled={true}
              value={primaryPrivateCidr}
              onChange={(event) => {
                setPrimaryPrivateCidr(event.target.value);
              }}
            />
            <FormHelperText>
              The CIDR block for the primary private subnet.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Secondary Private CIDR</FormLabel>
            <Input
              disabled={true}
              value={secondaryPrivateCidr}
              onChange={(event) => {
                setSecondaryPrivateCidr(event.target.value);
              }}
            />
            <FormHelperText>
              The CIDR block for the secondary private subnet.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Primary Public CIDR</FormLabel>
            <Input
              disabled={true}
              value={primaryPublicCidr}
              onChange={(event) => {
                setPrimaryPublicCidr(event.target.value);
              }}
            />
            <FormHelperText>
              The CIDR block for the primary public subnet.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Secondary Public CIDR</FormLabel>
            <Input
              disabled={true}
              value={secondaryPublicCidr}
              onChange={(event) => {
                setSecondaryPublicCidr(event.target.value);
              }}
            />
            <FormHelperText>
              The CIDR block for the secondary public subnet.
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};
